// здесь будет класс который будет создавать main menu из permissions

import mainMenuTemplateBASE from './mainMenuTemplateBASE.json.js'
// import permissions from './mainMenuPermissions.json.js'

import serverData from '@/store/serverData'

function copyMenuItems (refComponent, menuTemplate, menu, perms) {
  for (var i = 0; i < menuTemplate.length; i++) {
    if ((menuTemplate[i].id === 1 /* инфопанель отображаем всегда для всех */) || ((perms[menuTemplate[i].id] != null) && (perms[menuTemplate[i].id].val === true))) {
      if ((menuTemplate[i].id === 9805) && (refComponent.appSettings.company.config.appModules.vending !== true)) continue

      var item = Object.assign({}, menuTemplate[i])
      menu.push(item)

      if (menuTemplate[i].children != null) {
        item.children = []
        copyMenuItems(refComponent, menuTemplate[i].children, item.children, perms)
      }
    }
  }
}

export default {
  makeMenu (refComponent, cb) {
    // FOR TESTS:
    // setTimeout(function () {
    // refComponent.activeUserSet(refComponent.commonData.users[7]) // ремезова
    // refComponent.activeUserSet(refComponent.commonData.users[8]) // малюгина
    // refComponent.activeUserSet(refComponent.commonData.users[17]) // нарине
    // refComponent.activeUserSet(refComponent.commonData.users[93]) // шабрина
    // refComponent.activeUserSet(refComponent.commonData.users[92]) // остаольные (лукьянович)

    var menu = []

    var permissions = serverData.appSettings.mainMenuPermissionsByUserGroups
    var perms = permissions[0].val
    if (permissions[refComponent.activeUser.GroupID] != null) perms = permissions[refComponent.activeUser.GroupID].val

    // FOR TESTS:
    // perms = permissions[0]

    copyMenuItems(refComponent, mainMenuTemplateBASE, menu, perms)
    refComponent.mainMenuSet(menu)
    // }, 1000)
  }
}



// WEBPACK FOOTER //
// ./src/components/MainMenu/mainMenuMaker.js